<div class="sidesheet mat-elevation-z2">
  <div>
    <mat-form-field class="full-width">
      <mat-select [(value)]="mesSeleccionado" (valueChange)="cambiarMes($event)" placeholder="Seleccione un mes">
        <mat-option *ngFor="let mes of mesesDisponibles" [value]="mes.id">{{mes.label}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <nivelaciones-convenciones [direccion]="'vertical'" [completo]="'true'"
                             [asistencia]="true"></nivelaciones-convenciones>
</div>
<!--*ngIf="dataReady"-->

<div>
  <ng-container *ngFor="let nivelacion of nivelaciones">
    <div style="width: calc(100% - 48px); margin: 48px auto; padding-right: 332px; padding-left: 15px;">
      <div class="materia">
        <h4 class="mat-h2">{{nivelacion.materia.nombreCompleto}}</h4>
        <div class="materiaContenido mat-elevation-z2">
          <div class="materiaInfo">
            <div class="profesores">
              <ng-container *ngFor="let profesor of nivelacion.profesores">
                <div class="profesor">
                  <p class="profesor__nombre">{{profesor.nombresApellidos}}
                    <small class="profesor__otros">{{profesor.eMail}}</small>
                  </p>
                </div>
              </ng-container>
            </div>
            <span class="spacer"></span>
          </div>
          <div class="mat-table">
            <div class="mat-header-row">
              <div class="mat-header-cell">Franja</div>
              <ng-container *ngFor="let fecha of nivelacion.fechas">
                <div class="mat-header-cell">{{fecha.fecha}}</div>
              </ng-container>
            </div>
            <ng-container *ngFor="let alumno of nivelacion.alumnos">
              <ng-container *ngFor="let franja of alumno.franjas">
                <div class="mat-row">
                  <div class="mat-cell">{{franja.horaCita}}</div>
                  <div class="mat-cell" *ngFor="let fecha of franja.fechas">
                    <ng-container
                      *ngIf="fecha.conflicto && fecha.conflicto.isConflicto; else editable">
                      <mat-icon matTooltip="Reservado por {{fecha.conflicto.profesor}} {{fecha.conflicto.materia}}">
                        not_interested
                      </mat-icon>
                    </ng-container>
                    <ng-template #editable>
                      <ng-container *ngIf="!fecha.asistencia && fecha.isEditable">
                        <mat-checkbox color="primary" [value]="fecha.id"
                                      [checked]="fecha.citado"
                                      (change)="cambiarCitacion($event, fecha, nivelacion.materia.nombreCompleto, nivelacion.profesores)">
                        </mat-checkbox>
                      </ng-container>

                      <ng-container
                        *ngIf="!fecha.asistencia && !fecha.isEditable && fecha.citado">
                                            <span class="circulo" [ngClass]="{'neutral': fecha.noReportaAsistencia,
                                      'error': fecha.ausente,
                                      'warn': fecha.retardo,
                                      'success': fecha.presente}">
                                            </span>
                      </ng-container>
                    </ng-template>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
